import { Route } from 'react-router-dom';

import MedsusIndexSes from '../../Medsus';
import MedsusFichaSes from '../../Medsus/Ficha';

const MedsusRoutes = () => {
  return (
    <>
      {/* Básico */}
      <Route path="medsus/gestao" element={<MedsusIndexSes />} />
      <Route path="medsus/gestao/dadosgerais" element={<MedsusFichaSes />} />
      <Route
        path="medsus/gestao/:id/dadosgerais"
        element={<MedsusFichaSes />}
      />
    </>
  );
};

export default MedsusRoutes;
